import { api, helpers } from "../../utils";
const { stored } = api.net.config;
const cafe = {
    sms: {
        exist: {
            email: "Email này đã được đăng ký, bạn vui lòng chọn email khác!",
            phone: "Số điện thoại này đã được đăng ký, bạn vui lòng chọn số điện thoại khác",
            temp: "Thông tin này bạn đã đăng ký rồi, hãy F5 lại trình duyệt để xác thực!",
        },
        invalid_inputs: api.sms.invalid_inputs,
    },
};
const hlog = helpers.html.log;
const tRemove = helpers.text.remove;

const login = async ({ commit }, payload) => {
    let resolve;
    let p = new Promise(r => resolve = r);
    hlog.start("login", "start", payload);
    const res = await api.node.origin.login(payload);
    if (!res || !res.is_success) {
        commit("updateUAMember", { mem: null }, { root: true });
        resolve({ error: res.error });
    } else {
        commit("updateUAMember", { mem: res.data }, { root: true });
        resolve(res.data);
    };

    return p;
};

const logout = ({ commit }) => {
    let p = new Promise(async (resolve) => {
        const res = await api.node.origin.logout();
        commit("updateUAMember", { mem: null }, { root: true });
        resolve(res);
    });

    return p;
};

const upload = async (_, payload) => {
    let p = new Promise(async (resolve) => {
        if (!payload || !(payload.file instanceof File)) return resolve({ error: cafe.sms.invalid_inputs });
        const { key, file, name } = payload;
        let fileName = tRemove.diacritics(name);
        hlog.start("authen.upload", "start", file.name);
        let formData = new FormData();
        let extname = file.name.split(".").pop();
        formData.append(key, file, `${fileName}.${extname}`);
        const res = await api.node.origin.upload(formData);
        hlog.end("authen.upload", "end", res);
        if (!res || !res.is_success) resolve({ error: res.error });
        else resolve({ data: res.data });
    });

    return p;
};

const remove = async (_, payload) => {
    let p = new Promise(async (resolve) => {
        hlog.start("authen.remove", "start", payload);
        if (!payload || !payload.files) return resolve({ error: cafe.sms.invalid_inputs });
        const res = await api.node.origin.remove(payload);
        if (!res || !res.is_success) resolve({ error: res.error });
        else resolve({ data: res.data });
    });

    return p;
};

const register = ({ state, dispatch, commit }, payload) => {
    const p = new Promise(async (resolve) => {
        if (typeof (payload) !== "object") return resolve({ error: cafe.sms.invalid_inputs });
        const { Email, PhoneNumber } = payload;
        if (!Email || !PhoneNumber) return resolve({ error: cafe.sms.invalid_inputs });
        let fCheck = { Email, PhoneNumber };
        hlog.start("authen.register.check", "start", fCheck);
        const res_check = await api.net.data.warehouse.load.topOne({ storeName: stored.dw.CheckNewMember, filter: fCheck });
        hlog.end("authen.register.check", "end", res_check);
        let isNotValid = !res_check || !res_check.isSuccess;
        if (isNotValid) return resolve({ error: res_check.error });
        const { CountEmail, CountPhoneNumber, CountTempMembers } = res_check.data;
        if (CountPhoneNumber) return resolve({ error: cafe.sms.exist.phone });
        if (CountEmail) return resolve({ error: cafe.sms.exist.email });
        if (CountTempMembers) return resolve({ error: cafe.sms.exist.temp });
        let IP = await dispatch("loadIP", null, { root: true });
        const { ConsignorName, MemberName, Avatar, DateOfBirth, Gender } = payload;
        let filter = {
            ConsignorName, MemberName, Avatar, Gender,
            DateOfBirth, Email, IP, PhoneNumber,
        };
        hlog.start("authen.register.check", "filter", filter);
        const res_add = await api.node.origin.register(filter);
        hlog.end("authen.register.check", "end", res_add);
        isNotValid = !res_add || !res_add.is_success;
        if (isNotValid) return resolve({ error: res_add.error });
        state.temp = res_add.data;
        commit({ type: "loadData", data: state });
        resolve({ is_success: true, data: state.temp });
    });

    return p;
};

const activate = ({ state, commit }, payload) => {
    const p = new Promise(async (resolve) => {
        if (!payload || !payload.ActiveCode) return resolve({ error: cafe.sms.invalid_inputs });
        const { ActiveCode, Password, Avatar } = payload;
        let filter = { ActiveCode, Password, Avatar };
        hlog.start("authen.activate", "start", filter);
        const res = await api.node.origin.activate(filter);
        hlog.start("authen.activate", "end", res);
        let isNotValid = !res || !res.is_success;
        if (isNotValid) return resolve({ error: res.error });
        state.temp = res.data;
        commit({ type: "loadData", data: state });
        resolve({ is_success: true, data: res.data });
    });

    return p;
};

const loadActive = ({ rootState, state, commit }) => {
    const p = new Promise(async (resolve) => {
        let { headers } = rootState.useragent;
        if (!headers || !headers.SessionID) return resolve({ error: cafe.sms.session_timeout });
        const { SessionID } = headers;
        let filter = { SessionID };
        hlog.start("authen.load.active", "start", filter);
        state.temp = {};
        const res = await api.net.data.warehouse.load.list({ storeName: stored.dw.GetTempMember, filter });
        hlog.end("authen.load.active", "end", res);
        let isNotValid = !res || !res.isSuccess || !Array.isArray(res.data) || !res.data.length;
        if (isNotValid) return resolve(state.temp);
        state.temp = res.data[0];
        commit({ type: "loadData", data: state });
        resolve(state.temp);
    });

    return p;
};

const loadConfig = ({ rootState, state }) => {
    const p = new Promise(async (resolve) => {
        let { headers } = rootState.useragent;
        if (!headers || !headers.SessionID) return resolve({ error: cafe.sms.session_timeout });
        const { SessionID } = headers;
        let filter = { SessionID };
        hlog.start("authen.load.config", "start", filter);
        const res_config = await api.net.data.bot.load.list({ storeName: stored.GetMemberConfig, filter });
        hlog.end("authen.load.config", "end", res_config);
        // let res = { isSuccess: true, data: state.config };
        let isNotValid = !res_config || !res_config.isSuccess || !Array.isArray(res_config.data) || !res_config.data.length;
        if (isNotValid) return resolve({ isSuccess: true, data: state.config });
        let item = res_config.data[0];
        try {
            let ConfigExtension = item.ConfigExtension || JSON.stringify({});
            let ConfigToolFile = item.ConfigToolFile || JSON.stringify({});
            let ConfigToolQRCode = item.ConfigToolQRCode || JSON.stringify({});
            ConfigExtension = JSON.parse(ConfigExtension);
            ConfigToolFile = JSON.parse(ConfigToolFile);
            ConfigToolQRCode = JSON.parse(ConfigToolQRCode);
            state.config = { ConfigExtension, ConfigToolFile, ConfigToolQRCode };
        } catch (error) {
            hlog.error("authen.load.config", "error", error);
        };
        // commit({ type: "loadData", data: state });
        resolve({ isSuccess: true, data: state.config });
    });

    return p;
};

export default {
    login,
    logout,
    upload,
    remove,
    register,
    activate,
    loadActive,
    loadConfig,
};



// WEBPACK FOOTER //
// src/store/authen/actions.js